import {
  FetchGlobalCompanyTabCacheKey,
  FetchGlobalCompanyTabsCacheKey
} from './globalCompanyTabsTypes';

export class GlobalCompanyTabsCache {
  static indexCacheKey() {
    return 'global-company-tabs' as FetchGlobalCompanyTabsCacheKey;
  }

  static showCacheKey() {
    return 'global-company-tab' as FetchGlobalCompanyTabCacheKey;
  }
}
